const getCookie = (name) => {
    const escape = (s) => s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1');

    let match = document.cookie.match(
        RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)')
    );

    return match ? match[1] : null;
};

// const parseJSON = (response) => response.json();

const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};

const buildHeaders = () => {
    return {
        ...defaultHeaders,
    };
};

const buildHeadersWithCsrf = () => {
    return {
        'X-CSRFToken': getCookie('csrftoken'),
        ...defaultHeaders,
    };
};

// const checkStatus = (response) => {
//     if (response.status >= 200 && response.status < 300) {
//         return response;
//     }

//     const error = new Error(response.statusText);
//     error.response = response;
//     throw error;
// };

const httpGet = (url) => {
    console.log('httpGet', url);
    return fetch(url, {
        headers: buildHeaders(),
        credentials: 'same-origin',
    }).then((response) => response.json());
};
// .then(checkStatus)
// .then(parseJSON);

const httpGetWithCsrfToken = (url) =>
    fetch(url, {
        headers: buildHeadersWithCsrf(),
        credentials: 'same-origin',
    });
// .then(checkStatus)
// .then(parseJSON);

const httpPostWithCsrfToken = (url, data) =>
    fetch(url, {
        method: 'post',
        headers: buildHeadersWithCsrf(),
        body: JSON.stringify(data),
        credentials: 'same-origin',
    });
// .then(checkStatus)
// .then(parseJSON);

const httpDeleteWithCsrfToken = (url) =>
    fetch(url, {
        method: 'delete',
        headers: buildHeadersWithCsrf(),
        credentials: 'same-origin',
    });

const httpPost = (url, data) =>
    fetch(url, {
        method: 'post',
        headers: buildHeaders(),
        body: JSON.stringify(data),
        credentials: 'same-origin',
    });
// .then(checkStatus)
// .then(parseJSON);

export {
    httpDeleteWithCsrfToken,
    httpGet,
    httpGetWithCsrfToken,
    httpPost,
    httpPostWithCsrfToken,
};
